import { defineStore } from 'pinia'
import { shallowRef } from 'vue'

import type { PreviewModel } from '@/models/preview'

export const usePreviewStore = defineStore('preview', () => {
  const document = shallowRef<PreviewModel | null>(null)

  function setDocument(nextDocument: PreviewModel) {
    document.value = nextDocument
  }

  function clearDocument() {
    document.value = null
  }

  return {
    document,
    setDocument,
    clearDocument,
  }
})
